'use strict'

module.exports = Groupon.verifyUserCookies = ->
  setTimeout (->
    return unless src = Groupon.endpoints.verifyCookies
    # test if verification was already done in current session
    return if window.sessionStorage?.getItem('verifiedCookies')
    el = document.createElement('script')
    el.id = 'verify_cookies'
    el.async = true
    document.body.appendChild(el).src = src
    try
      sessionStorage?.setItem('verifiedCookies', true)
), 0



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/verifyUserCookies.coffee